import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSlider from './components/HeroSlider';
import TrustBlock from './components/TrustBlock';
import TourSearchForm from './components/TourSearchForm';
import BenefitsSection from './components/BenefitsSection';
import PopularToursSection from './components/PopularToursSection';
import TourTypesSection from './components/TourTypesSection';
import InspirationSection from './components/InspirationSection';
import DirectionsSection from './components/DirectionsSection';
import TeamSection from './components/TeamSection';
import NewsSection from './components/NewsSection';
import ReviewsSection from './components/ReviewsSection';
import BlogSection from './components/BlogSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSlider />
        <div className="max-w-[1360px] mx-auto px-6">
          <TrustBlock />
          <TourSearchForm />
        </div>
        <BenefitsSection />
        <PopularToursSection />
        <InspirationSection />
        <TourTypesSection />
        <DirectionsSection />
        <TeamSection />
        <NewsSection />
        <ReviewsSection />
        <BlogSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
